export const ReactionGifs = {
    'POSITIVE': [
        'http://i.imgur.com/sIWIJH4.gif',
        'http://i.imgur.com/Hy2Lrk4.gif',
        'http://i.imgur.com/2coInap.gif',
        'http://i.imgur.com/9Tku4Wd.gif',
        'http://i.imgur.com/KSvQiFy.gif',
        'http://i.imgur.com/SSjDQiv.gif',
        'http://i.imgur.com/3AtOUlZ.gif',
        'http://i.imgur.com/iz6ltWR.gif',
        'http://i.imgur.com/3AtOUlZ.gif',
        'http://i.imgur.com/O6qEtoy.gif',
        'http://i.imgur.com/lpPY7uJ.gif',
        'http://i.imgur.com/UQtcxhg.gif',
        'http://i.imgur.com/H52h70i.gif',
        'http://i.imgur.com/UDVXPHA.gif',
        'http://i.imgur.com/pe0fWrW.gif',
        'http://i.imgur.com/EQfwcl1.gif',
        'http://i.imgur.com/opVbQSD.gif',
        'http://i.imgur.com/xiM7A6k.gif',
        'http://i.imgur.com/tl91hI5.gif',
        'http://i.imgur.com/gJY0W9f.gif',
        'http://i.imgur.com/Aimxr0i.gif',
        'http://i.imgur.com/jRLVmsZ.gif',
        'http://i.imgur.com/9rROEJe.gif',
        'http://i.imgur.com/QvHnuKa.gif',
        'http://i.imgur.com/ZjdcnWR.gif',
        'http://i.imgur.com/vlOGTOk.gif',
        'http://i.imgur.com/6czE1dy.gif',
        'http://i.imgur.com/WjdDD8d.gif',
        'http://i.imgur.com/48tAtnx.gif',
        'http://i.imgur.com/OhtbYCP.gif',
        'http://i.imgur.com/qELEk3A.gif',
        'http://i.imgur.com/h2OcCge.gif',
        'http://i.imgur.com/fDxyK2X.gif',
        'http://i.imgur.com/gOyCBNa.gif',
        'http://i.imgur.com/xl3t3.gif',
        'http://i.imgur.com/Pqsa4JN.gif',
        'http://i.imgur.com/z9lljpz.gif',
        'http://i.imgur.com/SIG34A5.gif',
        'http://i.imgur.com/qRqCynQ.gif',
        'http://i.imgur.com/KPf0knJ.gif',
        'http://i.imgur.com/89j4E9h.gif',
        'http://i.imgur.com/SrZMqHt.gif',
        'http://i.imgur.com/sVgLfzS.gif',
        'http://i.imgur.com/CpccuKT.gif',
        'http://i.imgur.com/O5W3iRF.gif',
        'http://i.imgur.com/mBiHcFs.gif',
        'http://i.imgur.com/iTAhGKr.gif',
        'http://i.imgur.com/K0ZcGg9.gif',
        'http://i.imgur.com/0Zqv5nO.gif',
        'http://i.imgur.com/5rlTDKf.gif',
        'http://i.imgur.com/YbJHMDW.gif',
        'http://i.imgur.com/imm11gN.gif',
        'http://i.imgur.com/jbrTTGv.gif',
        'http://i.imgur.com/BkaNRtZ.gif',
        'http://i.imgur.com/1nNMGFf.gif',
        'http://i.imgur.com/8vtKICJ.gif',
        'http://i.imgur.com/8EbC9gh.gif',
        'http://i.imgur.com/dxufvDe.gif'
    ],
    'NEGATIVE': [
        'http://i.imgur.com/4cPS4ze.gif',
        'http://i.imgur.com/peDrySE.gif',
        'http://i.imgur.com/BLmxzII.gif',
        'http://i.imgur.com/uuj7VBZ.gif',
        'http://i.imgur.com/NNe9zzH.gif',
        'http://i.imgur.com/MW91hXy.gif',
        'http://i.imgur.com/H3sEaum.gif',
        'http://i.imgur.com/Wm29Ifz.gif',
        'http://i.imgur.com/Br3LQ0F.gif',
        'http://i.imgur.com/eFDv817.gif',
        'http://i.imgur.com/01aIaUb.gif',
        'http://i.imgur.com/7uVm12E.gif',
        'http://i.imgur.com/IauRcWH.gif',
        'http://i.imgur.com/2grdwkY.gif',
        'http://i.imgur.com/vax2Nbw.gif',
        'http://i.imgur.com/ECYYcNL.gif',
        'http://i.imgur.com/llxJp8J.gif',
        'http://i.imgur.com/gDf8zdX.gif',
        'http://i.imgur.com/LaGmmER.gif',
        'http://i.imgur.com/Fh8jjTN.gif',
        'http://i.imgur.com/LODbYBO.gif',
        'http://i.imgur.com/AYFtB31.gif',
        'http://i.imgur.com/TZp3c8K.gif',
        'http://i.imgur.com/48LAIQr.gif',
        'http://i.imgur.com/fqd9uUj.gif',
        'http://i.imgur.com/7fQux.gif',
        'http://i.imgur.com/DTErxov.gif',
        'http://i.imgur.com/yOGVQtG.gif',
        'http://i.imgur.com/8MMeudB.gif',
        'http://i.imgur.com/ud2ItGr.gif',
        'http://i.imgur.com/oJzajDC.gif',
        'http://i.imgur.com/IoghcDl.gif',
        'http://i.imgur.com/GU7SNHS.gif',
        'http://i.imgur.com/pvtFz21.gif',
        'http://i.imgur.com/ioLRU4q.gif',
        'http://i.imgur.com/IjffUUQ.gif',
        'http://i.imgur.com/qwZzwBE.gif',
        'http://i.imgur.com/vL1P3KV.gif',
        'http://i.imgur.com/u761gZx.gif',
        'http://i.imgur.com/v6DGjdO.gif',
        'http://i.imgur.com/z3NMd4q.gif',
        'http://i.imgur.com/m4pPQkw.gif',
        'http://i.imgur.com/5PeNIVI.gif',
        'http://i.imgur.com/tNq3G.gif',
        'http://i.imgur.com/8rV82xC.gif',
        'http://i.imgur.com/RFSgkaw.gif',
        'http://i.imgur.com/Ji6BvYc.gif',
        'http://i.imgur.com/BeADxF9.gif',
        'http://i.imgur.com/67T89Wo.gif',
        'http://i.imgur.com/MjQADxt.gif',
        'http://i.imgur.com/witqVHh.gif',
        'http://i.imgur.com/kt4Mkha.gif',
        'http://i.imgur.com/ThoviAb.gif',
        'http://i.imgur.com/o6hdDAT.gif',
        'http://i.imgur.com/KRQzPSy.gif',
        'http://i.imgur.com/ZJPNSn3.gif',
        'http://i.imgur.com/RETK045.gif',
        'http://i.imgur.com/oOMsaCs.gif',
        'http://i.imgur.com/NOW7TUF.gif'
    ]
}



// WEBPACK FOOTER //
// ./public/components/common/ReactionGifs.jsx